import API from 'utils/api';
import CRUDgeneric from 'utils/CRUDgeneric';

const baseURI = 'nominas/descuentos-percepciones/';

const CRUDdescuentosConfigPercepcion = CRUDgeneric(baseURI);

export default CRUDdescuentosConfigPercepcion;
